/**
 * author: 季札 <jizha.wyj@taobao.com>
 *
 * SPM 埋点脚本 for wap
 * 本脚本完全独立，不赖其它 js，可单独使用
 *
 * @see http://wiki.ued.taobao.net/doku.php?id=tms:spm%E5%9F%8B%E7%82%B9%E6%96%B9%E6%A1%88
 */

(function () {

	var win = window;
	var doc = document;
	var loc = location;
	var s_true = true;
	var s_false = false;

	var page_url = loc.href; // 当前页面的 url
	var loc_protocol = loc.protocol;
	var is_https = "https:" == loc_protocol;
	//var isOffline = getMetaOffline();
	var isTouchEnabled = getMetaTouch();
	var use_protocol = is_https ? "https:" : "http:";

	/**
	 * 2013-07-22
	 * 这儿不用 // 相对协议，是因为：
	 * 由校：是云OS浏览器的首页~ 浏览器首页需要马上加载出来，所以用file协议
	 *        浏览器在启动的时候会加载一个本地的html页面作为浏览器首页
	 *
	 * 2013-09-18
	 * 非 https 页面改用 gm.mmstat.com 域名，
	 * https 页面继续使用 log.mmstat.com ，因为 gm.mmstat.com 的证书目前还有问题
	 *
	 * 2015-06-03
	 * https 页面同样使用 wgo.mmstat.com
	 */
	var hjlj_beacon_base = (use_protocol) + "//wgo.mmstat.com/";



	var is_dom_ready = s_false;
	var is_in_iframe = parent !== self;

	var spm_a, spm_b, spm_ab;
	var spm_d_for_ad = {}; // 用于广告的spm_d位
	var page_global_spm_id_origin;
	var page_global_is_wangpu;
	var default_ab = "0.0";
	var is_use_default_ab = false;
	var s_plain_obj = "::-plain-::"; // 一个特殊的字符串，用于标识无需编码的键值
	var s_HTML = "HTML";
	var s_BODY = "BODY";

	var pvid;

	// 当前浏览器是否为 IE（是否支持 document.attachEvent）
	var atta = !!doc.attachEvent;
	var s_attachEvent = "attachEvent";
	var s_addEventListener = "addEventListener";
	var onevent = atta ? s_attachEvent : s_addEventListener;

	var _head_node;
	var _meta_nodes;

	var wh_in_page = s_false; // 页面上是否有无痕埋点
	var wh_spm_data = {}; // 无痕 SPM 数据，key 为 xpath
	var wh_spm_initialized = s_false;

	var spm_protocol;

	var s_SPM_ATTR_NAME = "data-spm";
	var s_SPM_DATA_PROTOCOL = "data-spm-protocol";
	var s_SPM_SRC = "data-spm-src";
	var s_SPM_CLICK = "data-spm-click";
	var s_AUTO_SPMD = "data-auto-spmd"; // @see http://gitlab.alibaba-inc.com/alilog/kb/issues/125
	var s_SPM_MAX_IDX = "data-spm-max-idx";
	var s_AUTO_SPMD_MAX_IDX = "data-auto-spmd-max-idx";

	var spm_prefix = ""; // 如果当前在iframe中，并且iframe有spm参数，则这个前缀不为空
	var spm_current_anchor;

	var s_DATA_SPM_WANGPU_MODULE_ID = "data-spm-wangpu-module-id";
	var s_DATA_SPM_ANCHOR_ID = "data-spm-anchor-id";


	/**
	 * 将一个 node list 转为数组
	 * @param nodes {NodeList}
	 * 参见：http://www.planabc.net/2010/01/06/arguments_to_array/
	 */
	function nodeListToArray(nodes) {
		var arr, length;

		try {
			// works in every browser except IE
			arr = [].slice.call(nodes);
			return arr;
		} catch (err) {
			// slower, but works in IE
			arr = [];
			length = nodes.length;

			for (var i = 0; i < length; i++) {
				arr.push(nodes[i]);
			}

			return arr;
		}
	}

	function tryToGetAttribute(element, attr_name) {
		return element && element.getAttribute ? (element.getAttribute(attr_name) || "") : "";
	}

	function tryToSetAttribute(element, attr_name, attr_value) {
		if (element && element.setAttribute) {
			try {
				element.setAttribute(attr_name, attr_value);
			} catch (e) {
			}
		}
	}

	function tryToRemoveAttribute(element, attr_name) {
		if (element && element.removeAttribute) {
			try {
				element.removeAttribute(attr_name);
			} catch (e) {
				tryToSetAttribute(element, attr_name, "");
			}
		}
	}

	/**
	 * 判断字符串 s1 是否以字符串 s2 开头
	 * @param s1 {String}
	 * @param s2 {String}
	 */
	function isStartWith(s1, s2) {
		return s1.indexOf(s2) == 0;
	}

	/**
	 * 判断字符串 s1 是否以黑名单中的字符串开头
	 * @param s1
	 */
	function isStartWithProtocol(s1) {
		var blacklist = ["javascript:", "tel:", "sms:", "mailto:", "tmall://"];
		for (var i = 0, l = blacklist.length; i < l; i++) {
			if (isStartWith(s1, blacklist[i])) {
				return true;
			}
		}
	}

	function isString(v) {
		return typeof v == "string";
	}

	function isArray(o) {
		return Object.prototype.toString.call(o) === "[object Array]";
	}

	function isNumber(v) {
		return typeof v == "number";
	}

	function hasString(s0, s1) {
		return s0.indexOf(s1) >= 0;
	}

	/**
	 * 判断字符串 s1 是否包含字符串 s2
	 * @param s1 {String}
	 * @param s2 {String}
	 */
	function isContain(s1, s2) {
		return s1.indexOf(s2) > -1;
	}

	function isContain2(s1, arr) {
		for (var i = 0, l = arr.length; i < l; i++) {
			if (isContain(s1, arr[i])) return s_true;
		}
		return s_false;
	}

	/**
	 * 去掉字符串 s 前后的空格
	 * @param s {String}
	 */
	function trim(s) {
		return isString(s) ? s.replace(/^\s+|\s+$/g, "") : "";
	}

	function isUnDefined(v) {
		return typeof v == "undefined";
	}

	function tryToDecodeURIComponent(val, default_val) {
		var v = default_val || "";
		if (val) {
			try {
				v = decodeURIComponent(val);
			} catch (e) {
			}
		}
		return v;
	}

	/**
	 * 取得页面上 head 中的所有 meta 元素
	 */
	function getMetaTags() {
		_head_node = _head_node || doc.getElementsByTagName("head")[0];

		return _meta_nodes || (_head_node ? (_meta_nodes = _head_node.getElementsByTagName("meta")) : []);
	}

	/**
	 * 解析 meta 的内容，meta 的内容形如："pageId=123; siteId=456"
	 * @param s {String}
	 * @param dict {Object}
	 */
	function parseMetaContent(s, dict) {
		var a = s.split(";"),
			j, a_len = a.length,
			a2;

		for (j = 0; j < a_len; j++) {
			a2 = a[j].split("=");
			dict[trim(a2[0]) || s_plain_obj] = tryToDecodeURIComponent(trim(a2.slice(1).join("=")));
		}
	}


	function getSPMProtocolFromMeta() {

		var metas = getMetaTags(),
			i, l,
			meta,
			meta_name;

		for (i = 0, l = metas.length; i < l; i++) {
			meta = metas[i];
			meta_name = tryToGetAttribute(meta, "name");
			if (meta_name == s_SPM_ATTR_NAME) {
				spm_protocol = tryToGetAttribute(meta, s_SPM_DATA_PROTOCOL);
//				spm_protocol = spm_protocol == "i" ? "i" : "u";
			}
		}

	}

	function getMetaSPMData(key) {
		var metas = getMetaTags(),
			i, l, a,
			meta, meta_name,
			tmp;

		if (metas) {
			for (i = 0, l = metas.length; i < l; i++) {
				meta = metas[i];
				meta_name = tryToGetAttribute(meta, "name");
				if (meta_name == key) {
					page_global_spm_id_origin = tryToGetAttribute(meta, "content");

					// 处理 spm 协议
					if (page_global_spm_id_origin.indexOf(":") >= 0) {
						a = page_global_spm_id_origin.split(":");
						spm_protocol = a[0] == "i" ? "i" : "u";
						page_global_spm_id_origin = a[1];
					}
					tmp = tryToGetAttribute(meta, s_SPM_DATA_PROTOCOL);
					if (tmp) {
						spm_protocol = (tmp == "i" ? "i" : "u");
					}

					// 旺铺页面全局 spm-id 无效
					page_global_is_wangpu = isStartWith(page_global_spm_id_origin, "110");
					spm_ab = (page_global_is_wangpu ? default_ab : page_global_spm_id_origin);

					return s_true;
				}
			}
		}

		return s_false;
	}

	/**
	 * 取得 head / meta 中的 aplus-offline
	 * 形如：
	 * <meta name="aplus-offline" content="1">
	 */
	//function getMetaOffline() {
	//	var i, meta,
	//		meta_nodes = getMetaTags(),
	//		l = meta_nodes.length,
	//		content;
	//
	//	for (i = 0; i < l; i++) {
	//		meta = meta_nodes[i];
	//		if (tryToGetAttribute(meta, "name") == "aplus-offline") {
	//			content = tryToGetAttribute(meta, "content");
	//			break;
	//		}
	//	}
	//
	//	return content;
	//}

	/**
	 * 取得 head / meta 中的 aplus-touch
	 * 形如：
	 * <meta name="aplus-touch" content="1">
	 */
	function getMetaTouch() {
		var i, meta,
			meta_nodes = getMetaTags(),
			l = meta_nodes.length,
			content;

		for (i = 0; i < l; i++) {
			meta = meta_nodes[i];
			if (tryToGetAttribute(meta, "name") == "aplus-touch") {
				content = tryToGetAttribute(meta, "content");
				break;
			}
		}

		return content;
	}

	/**
     * 取得 head / meta 中的 aplus-offline
     * 形如：
     * <meta name="aplus-offline" content="1">
     */
    function getMetaOffline() {
        var i, meta,
            meta_nodes = getMetaTags(),
            l = meta_nodes.length,
            content;

        for (i = 0; i < l; i++) {
            meta = meta_nodes[i];
            if (tryToGetAttribute(meta, "name") == "aplus-offline") {
                content = tryToGetAttribute(meta, "content");
                break;
            }
        }

        return content;
    }


	/**
	 * 生成一个用于避免缓存的随机数
	 * 为了减少 url 长度，这个随机数据的长度定为 7 位，
	 * 为了减少碰撞，使用 16 进制数字
	 *
	 * 268435456 = 2 ^ 28 = 0xfffffff + 1
	 */
	function makeCacheNum() {
		return Math.floor(Math.random() * 268435456).toString(16);
	}

	/**
	 * object to param
	 * 将一个简单对象转化为 url 参数的形式
	 * 参见 arr2param() 方法
	 * @param obj {Object}
	 *
	 */
	function obj2param(obj) {
		var a = [], k, v;
		for (k in obj)
			if (obj.hasOwnProperty(k)) {
				v = "" + obj[k];
//				a.push(k == s_plain_obj ? v : (k + "=" + encodeURIComponent(v)));
				a.push(isStartWith(k, s_plain_obj) ? v : (k + "=" + encodeURIComponent(v)));
			}
		return a.join("&");
	}


	/**
	 * array to param
	 * 将一个简单的数组转化为 url 参数的形式，
	 * 其中数组为
	 *        [[k1, v1], [k2, v2], [k3, v3], ...]
	 * 的形式。
	 * 与 obj2param 相比，这个方法的好处是可以保证最后参数的顺序
	 * @param arr {Array}
	 * @return {String}
	 */
	function arr2param(arr) {
		var a = [], k, v,
			i, len = arr.length;

		for (i = 0; i < len; i++) {
			k = arr[i][0];
			v = arr[i][1];
			a.push(isStartWith(k, s_plain_obj) ? v : (k + "=" + encodeURIComponent(v)));
		}
		return a.join("&");
	}

	function tryToGetHref(anchor) {
		/**
		 * 这儿之所以要 try 一下，是因为如果 href 格式有误时，在 IE8/9 下 href 将无效，
		 * 读取 anchor.href 时会直接出错。
		 *
		 * 例如，如果：
		 *         <a href="http://shop64102844.taobao.com/search=y% 3D">测试</a>
		 * 注意它缺少“?”，并且在“%”后多了一个空格
		 * 在 IE8/9 下用 js 访问这个链接的 href 属性时会直接报错
		 */
		var href;
		try {
			href = trim(anchor.getAttribute("href", 2));
		} catch (e) {
		}

		return href || "";
	}


	/**
	 * 绑定事件
	 * @param obj {Element|Document|Window} DOM 元素
	 * @param event_type
	 * @param f
	 */
	function addEventListener(obj, event_type, f) {

		if (event_type == 'tap') {
			tapEventBind(obj, f);
			return;
		}

		// 绑定 document 的 mousedown 事件
		obj[onevent](
			(atta ? "on" : "") + event_type,
			function (e) {
				e = e || win.event;
				var el = e.target || e.srcElement;

				f(el);
			},
			s_false
		);

	}

	/**
	 * tap methods
	 * thx to @灵玉
	 */
	function tapEventBind(element, fn) {
		var isTouch = "ontouchend" in document.createElement("div"),
			tstart = isTouch ? "touchstart" : "mousedown";

		// KISSY mini
		var KISSY = win.KISSY;
		if (KISSY && KISSY.__touchModAdded && KISSY.one && isTouch) {

			KISSY.one(element).on('tap', function (e) {
				fn && fn(e.target);
			});
		} else if (win.REACT_TOUCH_TAP_FIXED && element && element.addEventListener) {

			// 绑定onTouchTap的元素
			element.addEventListener('_touchtap', function (e) {
				element._spmSended = false;
				fn && fn(e.target || e.srcElement);
				// 已经发送过埋点，mousedown不再发送
				element._spmSended = true;
			}, false);

			// 没有绑定onTouchTap，绑定onClick的元素
			element.addEventListener('mousedown', function (e) {
				!element._spmSended && fn && fn(e.target || e.srcElement);
				element._spmSended = false;
			}, false);

			// touchstart的时候清除
			element.addEventListener('touchstart', function (e) {
				element._spmSended = false;
			}, false);

		} else {

			addEventListener(element, tstart, function (el) {
				fn && fn(el);
			});
		}
	}

//    function tapEventBind(element, fn) {
//        var isTouch = "ontouchend" in document.createElement("div"),
//            tstart = isTouch ? "touchstart" : "mousedown",
//            tmove = isTouch ? "touchmove" : "mousemove",
//            tend = isTouch ? "touchend" : "mouseup",
//            i = {};
//        addEventListener(element, tstart, function(e) {
//            var p = "touches" in e ? e.touches[0] : (isTouch ? window.event.touches[0] : window.event);
//            i.startX = p.clientX;
//            i.startY = p.clientY;
//            i.endX = p.clientX;
//            i.endY = p.clientY;
//            i.startTime = +new Date();
//        });
//        addEventListener(element, tmove, function(e) {
//            var p = "touches" in e ? e.touches[0] : (isTouch ? window.event.touches[0] : window.event);
//            i.endX = p.clientX;
//            i.endY = p.clientY;
//        });
//        addEventListener(element, tend, function(e) {
//            if ((+new Date()) - i.startTime < 300 &&
//                Math.abs(i.endX - i.startX) + Math.abs(i.endY - i.startY) < 20) {
//                fn && fn(e);
//            }
//            i = {};
//        });
//    }


	/**
	 * DOMReady 方法，
	 */
	function onDOMReady(f) {

		var kissy = win["KISSY"];
		if (kissy) {
			// 如果页面上有 KISSY，使用 KISSY 的方法
			kissy.ready(f);

		} else if (win.jQuery) {
			// 如果页面上存在 jQuery，使用 jQuery 的方法
			jQuery(doc).ready(f);

		} else {

			// 判断页面是否已经加载完成
			if (doc.readyState === "complete") {
				// 如果页面已经加载完成，直接执行函数 f
				f();

			} else {
				// 使用 window 的 onload 事件
				addEventListener(win, "load", f);
			}

		}
	}

	/**
	 *
	 * @param url {String}
	 * @param [data] {Object|Array}
	 * @return {String}
	 */
	function sendData(url, data) {

		var img = new Image(),
			rnd_id = "_img_" + Math.random(),
			link_char = url.indexOf("?") == -1 ? "?" : "&",
			src,
			param_data = data ? (
				isArray(data) ? arr2param(data) : obj2param(data)
			) : "";

		// 在全局变量中引用 img，防止 img 被垃圾回收机制过早回收造成请求发送失败
		// 参考：http://oldj.net/article/one-thing-to-notice-about-new-image/
		win[rnd_id] = img;

		img.onload = img.onerror = function () {
			win[rnd_id] = null;
		};

		img.src = src = param_data ? (url + link_char + param_data) : url;
		img = null; // 删除临时变量的引用

		return src;
	}

	/**
	 * 取得全局 spm id
	 * 以 init_ 开头的函数是页面加载时就会执行的
	 * 步骤如下：
	 * 1、如果页面上存在无痕埋点，则使用无痕埋点数据
	 *         spm_a = window._SPM_a;
	 *         spm_b = window._SPM_b;
	 *         spm_protocol 从 head meta 中取
	 *
	 * 2、在 head 中查找
	 *         <meta name="spm-id" content="[Protocol:]xx.xx" />
	 *        或：<meta name="spm-id" content="[Protocol:]xx" />
	 *        或：<meta name="data-spm" content="[Protocol:]xx" />
	 * 如果找到，则；
	 *         如果其内容不以“110”开头，则使用；
	 *         否则，返回空（旺铺页面没有全局 spm-id） 2012-02-13 补庵、大渡需求
	 *
	 * 3、在 body 标签中查找 spm id 的第 2 位，如果找到，则使用（2012-06-06）
	 * @see: http://baike.corp.taobao.com/index.php/Spm%E5%9F%8B%E7%82%B9
	 *
	 * 4、否则，返回“0.0”
	 */
	function init_getGlobalSPMId() {

		var spm_in_current_url;
		if (is_in_iframe && !spm_prefix) {
			// 从当前iframe的url中获取spm前缀
			spm_in_current_url = page_url.match(/^[^?]+\?[^?]*spm=([^&#?]+)/);
			if (spm_in_current_url) {
				spm_prefix = spm_in_current_url[1] + "_";
			}
		}

		if (!isUnDefined(spm_ab)) return spm_ab;

		/** @namespace win._SPM_a */
		/** @namespace win._SPM_b */
		if (win._SPM_a && win._SPM_b) {
			// 如果页面上存在 _SPM_a、_SPM_b，表示页面上有无痕埋点
			spm_a = win._SPM_a.replace(/^{(\w+)}$/g, "$1");
			spm_b = win._SPM_b.replace(/^{(\w+)}$/g, "$1");
			wh_in_page = s_true;
			spm_ab = spm_a + "." + spm_b;
			getSPMProtocolFromMeta();

//			goldlog.spm_ab = [spm_a, spm_b];

			return spm_ab;
		}

//		var head = doc.getElementsByTagName("head")[0],
//			a;

		getMetaSPMData(s_SPM_ATTR_NAME) || getMetaSPMData("spm-id");

		/**
		 * 如果页面上不存在 spm id 的第一位，则返回默认值“0.0”
		 */
		if (!spm_ab) {
			is_use_default_ab = true;
			spm_ab = default_ab;
			return default_ab;
		}

		/**
		 * 尝试从 body 标签中获取第二位
		 * 形如：<body data-spm="1000484">...</body>
		 */
		var spm_b_val;
		var a;
		var body = doc.getElementsByTagName("body");
		body = body && body.length ? body[0] : null;
		if (body) {
			spm_b_val = tryToGetAttribute(body, s_SPM_ATTR_NAME);
			if (spm_b_val) {
				// body 标签中存在 spm 第二位
				a = spm_ab.split(".");
				spm_ab = a[0] + "." + spm_b_val;
//				goldlog.spm_ab = [a[0], spm_b_val];
			}
		}
		if (!isContain(spm_ab, ".")) {
			// 没有指定b位
			is_use_default_ab = true;
			spm_ab = default_ab;
		}

		return spm_ab;
	}


	function wh_getXPath(el) {

		var all_nodes = doc.getElementsByTagName("*"),
			segs, i, sib, unique_id_count,
			node, el_id;

		for (segs = []; el && el.nodeType == 1; el = el.parentNode) {
			if (el_id = el.id) {
				unique_id_count = 0;
				for (i = 0; i < all_nodes.length; i++) {
					node = all_nodes[i];
					if (node.id == el_id) {
						unique_id_count++;
						break;
					}
				}
				segs.unshift(el.tagName.toLowerCase() + "[@id=\"" + el_id + "\"]");
				if (unique_id_count == 1) {
					segs.unshift("/");
					return segs.join("/");
				}

			} else {
				for (i = 1, sib = el.previousSibling; sib; sib = sib.previousSibling) {
					if (sib.tagName == el.tagName)  i++;
				}
				segs.unshift(el.tagName.toLowerCase() + "[" + i + "]");
			}

		}

		return segs.length ? "/" + segs.join("/") : null;

	}

	function wh_isModule(el) {
		var data = wh_spm_data[wh_getXPath(el)];

		return data ? data.spmc : "";
	}

	/**
	 * 取得当前模块中的所有 a/area 元素，但是跳过子模块中的 a/area 元素
	 * @param el {Element}
	 * @param [is_auto_spmd] {Boolean} 是为带 data-auto-spmd 属性的元素
	 *          需求见 http://gitlab.alibaba-inc.com/alilog/kb/issues/125
	 * @return {Array}
	 */
	function spm_getModuleLinks(el, is_auto_spmd) {

		var els_a, els_area,
			anchor,
			anchors, tmp_el, arr = [],
			is_in_child_module,
			i, l;

		var auto_spmd;
		els_a = nodeListToArray(el.getElementsByTagName("a"));
		els_area = nodeListToArray(el.getElementsByTagName("area"));
		anchors = els_a.concat(els_area);

		for (i = 0, l = anchors.length; i < l; i++) {
			is_in_child_module = false;
			tmp_el = anchor = anchors[i];
			while (tmp_el = tmp_el.parentNode) {
				if (tmp_el == el) break;
				if (tryToGetAttribute(tmp_el, s_SPM_ATTR_NAME)) {
					// 如果当前链接是在另一个模块中
					is_in_child_module = true;
					break;
				}
			}
			if (!is_in_child_module) {
				auto_spmd = tryToGetAttribute(anchor, s_AUTO_SPMD);
				if (!is_auto_spmd && auto_spmd != "t") {
					arr.push(anchor);
				} else if (is_auto_spmd && auto_spmd == "t") {
					arr.push(anchor);
				}
			}
		}

		return arr;
	}


	/**
	 * 初始化一个 spm 模块
	 * 为其中的所有 a/area 元素（href 不为空）（跳过子模块）添加一个 data-spm-id 属性，同时添加相应的 url params
	 *
	 * 上面的跳过子模块的意思是：
	 * 如果一个容器中嵌套了另外的子容器，则编号时跳过这些子容器中的链接
	 *
	 * @param module {Element} 要初始化的 dom 节点
	 * @param spm_c {String} 可选，模块的 c 位值
	 * @param is_not_change_href {Boolean} 是否修改链接的 href
	 * @param [is_auto_spmd] {Boolean} 是否初始化 auto_spmd 链接
	 */
	function spm_initSPMModule(module, spm_c, is_not_change_href, is_auto_spmd) {

		var anchors, anchor, ids, ids0, anchor_idx,
			href, a_spm_id,
			spm_d,
			page_g_spm_id,
			length, i, j,
			is_in_wangpu_module, // 是否为旺铺模块，旺铺的 spm id 以 110 开头
			wangpu_module_id,
//			wangpu_module_id_arr,
			current_module_max_spmid;

		if (tryToGetAttribute(module, "data-spm-delay")) {
			module.setAttribute("data-spm-delay", "");
			return;
		}

		spm_c = spm_c || module.getAttribute(s_SPM_ATTR_NAME) || "";
		if (!spm_c) return;
		anchors = spm_getModuleLinks(module, is_auto_spmd);
		if (anchors.length === 0) return;

		ids = spm_c.split(".");
		is_in_wangpu_module = (isStartWith(spm_c, "110") && ids.length == 3);
		if (is_in_wangpu_module) {
			wangpu_module_id = ids[2];
			ids[2] = "w" + (wangpu_module_id || "0"); // 补庵 2013-04-26 需求，SPM 参数采用完整的值
			spm_c = ids.join(".");
		}

		/*
		 * 在页面上查找全局的 meta spm 变量
		 * 并将它作为 spm_id 的前 n 位（n 为 1 或 2）
		 *
		 */
		if (
			isString(page_g_spm_id = init_getGlobalSPMId()) &&
			page_g_spm_id.match(/^[\w\-\*]+(\.[\w\-\*]+)?$/) // 格式为 xx.xx 或 xx 的形式
		) {
			if (!hasString(spm_c, ".")) {
				/**
				 * module 中只有第三位，则使用全局的前两位拼接
				 * @see: http://baike.corp.taobao.com/index.php/Spm%E5%9F%8B%E7%82%B9
				 */
				if (!hasString(page_g_spm_id, ".")) {
					// 容错处理，如果 meta 、module 中都只有一位，但是 body 中没有填写，则使用 0 代替
					page_g_spm_id += ".0";
				}
				spm_c = page_g_spm_id + "." + spm_c;

			} else if (!isStartWith(spm_c, page_g_spm_id)) {
				ids0 = page_g_spm_id.split(".");
				ids = spm_c.split(".");

				for (i = 0, length = ids0.length; i < length; i++) {
					ids[i] = ids0[i];
				}
				spm_c = ids.join(".");

//					if (ids.length == 3) {
//						spm_id = page_g_spm_id + "." + ids[2];
//					}
			}
		}

		// 判断当前 spm_id 是否合法
		if (!spm_c.match || !spm_c.match(/^[\w\-\*]+\.[\w\-\*]+\.[\w\-\*]+$/)) return;

		var max_id_attr = is_auto_spmd ? s_AUTO_SPMD_MAX_IDX : s_SPM_MAX_IDX;
		// 取得当前 module 的 data-spm-max-id 的值
		current_module_max_spmid = parseInt(tryToGetAttribute(module, max_id_attr)) || 0;

		for (j = 0, anchor_idx = current_module_max_spmid, length = anchors.length; j < length; j++) {
			anchor = anchors[j];
			href = tryToGetHref(anchor);

			// 忽略没有 href 的 anchor（这一般是书签）
			if (!is_auto_spmd && !href) continue;

			if (is_in_wangpu_module) {
				anchor.setAttribute(s_DATA_SPM_WANGPU_MODULE_ID, wangpu_module_id);
			}

			// 如果当前 a 元素已经有 spm id
			if (a_spm_id = anchor.getAttribute(s_DATA_SPM_ANCHOR_ID)) {

				// 再次确保当前 a 元素的 spm id 为 a_spm_id
				spm_anchorEnsureSPMId_inHref(anchor, a_spm_id, is_not_change_href);
				continue;
			}

			anchor_idx++;
//			anchor.href = hostname + "?spm=" + spm_id + "." + anchor_idx + search + hash;
			spm_d = (spm_getAnchor4thId_spm_d(anchor) || anchor_idx);
			if (is_auto_spmd) {
				spm_d = "at" + ((isNumber(spm_d) ? 1000 : "") + spm_d);
			}

			a_spm_id = spm_c + "." + spm_d;
			spm_anchorEnsureSPMId_inHref(anchor, a_spm_id, is_not_change_href);

		}

		// 记录下当前 module 的最大 anchor 索引
		module.setAttribute(max_id_attr, anchor_idx);

	}

	/**
	 * 判断当前 url 是否广告链接
	 * 广告链接黑名单
	 * @param url {String}
	 */
	function spm_isAdLink(url) {

		var ad_links = [
			"mclick.simba.taobao.com", // 无线点击
			"click.simba.taobao.com", // kgb的点击
			"click.tanx.com", // tanx的点击
			"click.mz.simba.taobao.com", // mama的点击
			"click.tz.simba.taobao.com", // mama的点击
			"redirect.simba.taobao.com", // redirect点击
			"rdstat.tanx.com", // redirect地址
			"stat.simba.taobao.com", // 隐樵 2012-5-20
			"s.click.taobao.com" // 隐樵 2012-5-20
		], i, len = ad_links.length;

		for (i = 0; i < len; i++) {
			if (url.indexOf(ad_links[i]) != -1) return true;
		}

		return false;
	}

	function spm_isAlipayUrl(url) {

		return url ?
			(!!url.match(/^[^\?]*\balipay\.(?:com|net)\b/i))
			: s_false;
	}

	/**
	 * 判断是不是 alipay 的签名链接
	 * 这种链接中的参数已经过签名，不能再添加 spm 参数，否则会出错
	 * @param url {String}
	 *
	 * 这种链接形如：
	 * http://tbapi.alipay.net/cooperate/gateway.do?_input_charset=GBK&amp;customer_email=twork_yexue06%40taobao.net&amp;is_account_read_only=true&amp;partner=2088001159940003&amp;return_url=http%3A%2F%2Ffenxiao.daily.taobao.net%2Fdistributor%2Fapply%2FsetdefaultPayway_callback.htm&amp;service=customer_sign&amp;type_code=TBFX100021000302&amp;sign_type=DSA&amp;sign=_f2_j_i%2B_ds_h_w_sfr_a_ld_s_z_iq_w_q5_uw_xb9xz_nf_na_fi3pc_gafcrpm_k_sm9_m_w_t_gg%3D%3D
	 *
	 * 特征为：
	 *     1、域名中包含 alipay.net 或 alipay.com；
	 *     2、参数中包含 /\bsign=.+/
	 */
	function spm_isAlipaySignedUrl(url) {
		return url ?
			(!!url.match(/^[^\?]*\balipay\.(?:com|net)\/.*\?.*\bsign=.*/i))
			: s_false;
	}

	/**
	 * 递归取得某个链接的父元素的 data-spm-protocol 的值
	 * @param el {HTMLElement|Node}
	 * @return {String}
	 */
	function spm_getModuleProtocol(el) {
		var tmp;
		while ((el = el.parentNode) && el.tagName != s_BODY) {
			tmp = tryToGetAttribute(el, s_SPM_DATA_PROTOCOL);
			if (tmp) return tmp;
		}
		return "";
	}

	/**
	 * 在给定的 href 中间插入 spm 参数，如果原来 href 中已有 spm，则将其更新
	 * @param href {String}
	 * @param spm_id {String}
	 */
	function spm_updateHrefWithSPMId(href, spm_id) {

		// 去掉现有的 href 中的 spm 参数
		if (href && /&?\bspm=[^&#]*/.test(href)) {
			href = href.replace(/&?\bspm=[^&#]*/g, "")
				.replace(/&{2,}/g, "&")
				.replace(/\?&/, "?")
				.replace(/\?$/, "")
			;
		}

		if (!spm_id) return href;

		// 在 href 中插入新的 spm 参数
		var search, hash, a,
			and_char = "&",
			query_split,
			query_count,
			filename,
			file_ext;

		if (href.indexOf("#") != -1) {
			a = href.split("#");
			href = a.shift();
			hash = a.join("#"); // 取第一个 # 后的部分
		}
		query_split = href.split("?");
		query_count = query_split.length - 1;

		// 下面处理形如“http://www.taobao.com”这样的末尾不带“/”的链接
		// 这种链接对应的filename为空
		a = query_split[0].split("//");
		a = a[a.length - 1].split("/");
		filename = a.length > 1 ? a.pop() : "";

		if (query_count > 0) {
			/**
			 * 由于存在类似 http://ju.atpanel.com/?scm=1005.10.1.703&url=http://www.tmall.com/go/act/tmall/mymx-ym.php?spm=1.1000386.222017.20&ad_id=&am_id=&cm_id=&pm_id=150100827263368085f8
			 * 这样的链接，注意其中有两个“?”，
			 * 这是一种跳转链接，其中 spm 参数需要加在后面一个 ? 之后，
			 * 经与梵易商量（2012-03-30），决定统一将 spm 参数加到 href 的最后一个 ? 之后
			 */
//			a = href.split("?");
			search = query_split.pop(); // 取最后一个 ? 后的部分
			href = query_split.join("?"); // 最后一个 ? 之前的部分
		}

		if (search &&
			query_count > 1 && // # 只对两个及以上的“?”的 url 执行这样的检测
			search.indexOf("&") == -1 &&
//			search.indexOf("=") == -1 &&
			search.indexOf("%") != -1) {
			/**
			 * 有一些页面，如 http://login.taobao.com/member/logout.jhtml?f=top&redirectURL=http://login.tmall.com/?spm=1007.100361.0.180%26redirect_url=http%253A%252F%252Ftemai.tmall.com%252F%253Fspm%253D3.1000473.197562.2%2526prt%253D1336367425196%2526prc%253D4
			 * spm 参数加在第二个 ? 之后，但是第二个 ? 之后的 & 都已经做了规范的转码，所以新添加的 spm 后面的 & 也要进行转码
			 */
			and_char = "%26";
		}

		href = href + "?spm=" + spm_prefix + spm_id
			+ (search ? (and_char + search) : "")
			+ (hash ? ("#" + hash) : "")
		;

		/**
		 * 添加文件名额外参数
		 * 由于在IE下，如果加了spm参数可能会引起文件后缀名被修改，
		 *
		 * 比如：
		 * 原始下载链接：
		 * http://download.alipay.com/sec/edit/aliedit.exe
		 *
		 * 加了spm参数之后：
		 * http://download.alipay.com/sec/edit/aliedit.exe?spm=a2107.1.1000341.10（有问题，IE下后缀名被修改为“.10”）
		 *
		 * 加了file参数之后：
		 * http://download.alipay.com/sec/edit/aliedit.exe?spm=a2107.1.1000341.10&file=aliedit.exe（没有问题）
		 *
		 * 因此，这儿会对形如文件下载的链接添加一个额外参数
		 */
		file_ext = isContain(filename, ".") ? filename.split(".").pop().toLowerCase() : "";
		if (file_ext) {
			if (({
					"png": 1,
					"jpg": 1,
					"jpeg": 1,
					"gif": 1,
					"bmp": 1,
					"swf": 1
				}).hasOwnProperty(file_ext)) {
				// 以图片后缀名结尾的链接不加 spm 参数
				return 0;
			}

			if (!search && query_count <= 1) {
				if (!hash && !({
						"htm": 1,
						"html": 1,
						"php": 1
					}).hasOwnProperty(file_ext)) {
					// 认为当前文件是一个下载文件，添加额外参数
					href += "&file=" + filename;
				}
			}
		}

		return href;
	}


	/**
	 * 判断当前 href 与当前页面的 page_url 之间除了“#”之后的内容是否完全相同
	 * @param href
	 */
	function spm_isHref_a_BookMark(href) {
		return href && (page_url.split("#")[0] == href.split("#")[0]);
	}


	/**
	 * 为一个 a 元素 的 href 添加 spm_id
	 * @param anchor {Element} a 元素
	 * @param a_spm_id {String} 完整的 spm_id，值为 a.b.c.d 四位，不包含最后的 pvid(logid)
	 * @param is_not_change_href {Boolean} 是否修改链接的 href
	 */
	function spm_anchorEnsureSPMId_inHref(anchor, a_spm_id, is_not_change_href) {

		anchor.setAttribute(s_DATA_SPM_ANCHOR_ID, a_spm_id);

		// 如果当前链接同时存在黄金令箭埋点，则退出，不执行 SPM 埋点
		if (is_not_change_href || tryToGetAttribute(anchor, s_SPM_CLICK)) return;

		// spm_id 末位加上 pvid

		// 取得 pvid 的值
//		pvid = win["g_aplus_pv_id"];
//		if (pvid) {
//			a_spm_id += "." + pvid;
//		}
//		if (!pvid && (!spm_ab || spm_ab == default_ab)) {
//			// 如果页面上没有指定pvid，同时没有指定spm A、B，那么不添加spm打点。
//			return;
//		}

		var href = tryToGetHref(anchor);
		var is_i_protocol = (
				tryToGetAttribute(anchor, s_SPM_DATA_PROTOCOL)
				|| spm_getModuleProtocol(anchor)
				|| spm_protocol
			) == "i";

		var i_protocol_beacon_url = hjlj_beacon_base + "tbspm.1.1?logtype=2&spm=";

		/**
		 * 如果链接的 href 为一个“#bookmark”的形式，
		 * 或链接为 <a href="javascript:..." 的形式，
		 * 或者为广告链接 （2012-05-18）
		 * 则跳过
		 */
		if (!href || spm_isAdLink(href)) return;
		if (!is_i_protocol && (
				isStartWith(href, "#")
				|| spm_isHref_a_BookMark(href)
				|| isStartWithProtocol(href.toLowerCase())
				|| spm_isAlipayUrl(href) // 2012-07-06 俊庭需求，
				/**
				 * 上面一行说明如下：
				 * 形如 http://download.alipay.com/sec/edit/aliedit.exe?spm=a2107.1.1000341.10 的链接，
				 * 在 IE 下载时，会下载为 aliedit.10，即将最后的“.10”当作文件后缀名了...
				 * 因此哲别需求：暂时对所有 alipay 链接都不加 spm 参数。
				 */
				|| spm_isAlipaySignedUrl(href)
			)) return;

		if (is_i_protocol) {
			/**
			 * 采用 i 协议
			 * 不修改链接地址，绑定 mousedown 事件，点击时发送额外打点请求
			 * /tbspm.1.1?spm=[.*]&url=[.*]，加cache缓存
			 */
			i_protocol_beacon_url += a_spm_id + "&url=" + encodeURIComponent(href) + "&cache=" + makeCacheNum();
			if (spm_current_anchor == anchor) {
				sendData(i_protocol_beacon_url);
			}

		} else if (!is_not_change_href) {
			/**
			 * 修改链接地址
			 */
			(href = spm_updateHrefWithSPMId(href, a_spm_id)) && spm_writeHref(anchor, href);
		}

	}

	/**
	 * 写链接 anchor 的 href 的值
	 * @param anchor {Element}
	 * @param href {String}
	 */
	function spm_writeHref(anchor, href) {

//			anchor.href = " " + href;
		/**
		 * 说明，这儿在 a 的 href 前面加了一个空格，
		 * 因为在 IE6/7/8 下，如果 a 链接的 innerHTML 中包含“@”字符，或者以“www.*”开头，则
		 * 在修改 href 属性时，innerHTML 也会跟着变。（这是一个 IE 的 bug）
		 * 参见：http://oldj.net/article/ie-bug-at-href-innerHTML/
		 *
		 * 同时，这儿的 innerHTML 可能是 <img> 等节点，并且可能已经绑定事件，如果先记下 innerHTML
		 * 迟些再写回去可能会造成已绑定的事件丢失，所以用了最简单的在前面加个空格的方法。
		 *
		 */

		/**
		 * 说明：
		 * 在 href 前面加一个空格的方式副作用太多，
		 * 这儿尝试使用加一个空 <b></b> 节点然后再删除的方法。
		 * 见：http://oldj.net/article/ie-bug-at-href-innerHTML/
		 *
		 * 参考：https://github.com/kissyteam/kissy/blob/master/src/dom/src/attr.js#L215
		 */
		var b,
			inner_html = anchor.innerHTML;

		if (inner_html && inner_html.indexOf("<") == -1) {
			b = doc.createElement("b");
			b.style.display = "none";
			anchor.appendChild(b);
		}
		anchor.href = href;

		if (b) {
			anchor.removeChild(b);
		}
	}


	/**
	 * 某些 a 链接可能指定了 SPM 第四位参数的值，对这些链接，需要使用指定的值
	 * @param el
	 */
	function spm_getAnchor4thId_spm_d(el) {
		var spm_d, xpath, data;

		if (is_use_default_ab) {
			spm_d = "0";
		} else if (wh_in_page) {
			xpath = wh_getXPath(el);
			data = wh_spm_data[xpath];
			if (data) {
				spm_d = data["spmd"];
			}


		} else {
			spm_d = tryToGetAttribute(el, s_SPM_ATTR_NAME);
			if (!spm_d || !spm_d.match(/^d\w+$/)) {
				spm_d = "";
			}
		}

		return spm_d;
	}


	/**
	 * 取得 el 元素的父元素的 spm_id，如果存在的话。
	 * el 一定是 a 的父元素，不会是 a 链接
	 * 就近原则：
	 *     如果 el 有多个父元素带 data-spm 属性，则只取离它最近的那一层。
	 * @param el {HTMLElement|Node}
	 */
	function spm_spmGetParentSPMId(el) {
		var spm_c,
			tmp_val, spm_el = el;

		while (el
		&& el.tagName != s_HTML // 如果 el 是 HTML 节点，则下一句 el.getAttribute 在 IE 下会直接报错
		&& el.tagName != s_BODY // body 中的 data-spm 属性的含义为第二位，模块的 data-spm 属性不能放在 body 标签上
		&& el.getAttribute
			) {

			if (!wh_in_page) {
				tmp_val = el.getAttribute(s_SPM_ATTR_NAME);
			} else {
				// 在无痕列表中查找当前模块的数据
				tmp_val = wh_isModule(el);
			}
			if (tmp_val) {
				spm_c = tmp_val;
				spm_el = el;
				break;
			}

			if (!(el = el.parentNode)) break;
		}

		// 如果 spm_c 不合法，则将它置 0
		if (spm_c && !/^[\w\-\.]+$/.test(spm_c)) {
			spm_c = "0";
		}

		return {
			spm_c: spm_c,
			el: spm_el
		};
	}

	function spm_getSPMIdFromHref(href) {
		var m;
		return (href && (m = href.match(/&?\bspm=([^&#]*)/))) ? m[1] : "";
	}

	/**
	 * 处理非 spm 模块的链接（即未指定 c 位）
	 * @param el_a {Element}
	 * @param is_not_change_href {Boolean} 是否修改链接的 href
	 */
	function spm_dealNoneSPMLink(el_a, is_not_change_href) {

		var href = tryToGetHref(el_a),
			spm_in_href = spm_getSPMIdFromHref(href),
			a_spm = null,
			meta_spm_is_valid = spm_ab && spm_ab.split(".").length == 2;

		if (meta_spm_is_valid) {

			// 使用 meta 中的前 2 位做 spm 的前 2 位，第 3 位固定取 0，第 4 位为指定的值或 0
			a_spm = [spm_ab, 0, spm_getAnchor4thId_spm_d(el_a) || 0];
			spm_anchorEnsureSPMId_inHref(el_a, a_spm.join("."), is_not_change_href);
			return;
		}

		// 其它情况下，清除 href 中的 spm
		if (href && spm_in_href) {
			href = href.replace(/&?\bspm=[^&#]*/g, "")
				.replace(/&{2,}/g, "&")
				.replace(/\?&/, "?")
				.replace(/\?$/, "")
				.replace(/\?#/, "#")
			;
			spm_writeHref(el_a, href);
		}
	}


	/**
	 * 点到了一个 a/area 元素上，检查当前 a/area 元素是否需要记录 spm 打点
	 * @param el_a {Element}
	 * @param is_not_change_href {Boolean} 是否不修改链接的 href 属性
	 *         此项如果为 true，则本次操作只写该链接的 data-* 属性，但不修改 href
	 */
	function spm_spmAnchorChk(el_a, is_not_change_href) {

		spm_current_anchor = el_a;

		var a_spm_id = tryToGetAttribute(el_a, s_DATA_SPM_ANCHOR_ID),
			spm_data,
			spm_c;

		if (!a_spm_id) {
			/**
			 * 当前链接没有 spm_id
			 * 递归检查它的祖先元素是否为 spm 打点元素
			 */

			spm_data = spm_spmGetParentSPMId(el_a.parentNode);
			spm_c = spm_data.spm_c;
			if (!spm_c) {
				spm_dealNoneSPMLink(el_a, is_not_change_href);

				return;
			}
			if (is_use_default_ab) spm_c = "0";

			// 是 spm 模块，但是没有初始化，下面将其初始化
			spm_initSPMModule(spm_data.el, spm_c, is_not_change_href);
			spm_initSPMModule(spm_data.el, spm_c, is_not_change_href, true);

			// 初始化之后，链接 a 元素应该具备 data-spm-anchor-id 属性
//				a_spm_id = tryToGetAttribute(el_a, s_DATA_SPM_ANCHOR_ID);

		} else {
			// 确保当前 a 元素有 spm_id 内容
			/**
			 * 这个操作主要是保证本 js 设置的值不会被老的 spm 打点 js 覆盖
			 * 老 spm js：http://a.tbcdn.cn/apps/tms/js/spm.js
			 * 将来可以将下面这行删除，以便节省资源。
			 */
			spm_anchorEnsureSPMId_inHref(el_a, a_spm_id, is_not_change_href);
		}

	}


	/**
	 * 清除一个 module 的所有编号数据
	 * 执行完这个方法后，再点击该模块时，该模块将重新编号
	 * @param el {Element}
	 */
	function spm_resetModule(el) {

		if (!el || el.nodeType != 1) return;

		tryToRemoveAttribute(el, s_SPM_MAX_IDX);
		tryToRemoveAttribute(el, s_AUTO_SPMD_MAX_IDX);

		var els_a = nodeListToArray(el.getElementsByTagName("a")),
			els_area = nodeListToArray(el.getElementsByTagName("area")),
			anchors = els_a.concat(els_area),
			i, len = anchors.length;

		for (i = 0; i < len; i++) {
			tryToRemoveAttribute(anchors[i], s_DATA_SPM_ANCHOR_ID);
		}

	}


	/**
	 * 取得用于广告的spm id
	 * @param el {Element} 非A/AREA元素
	 * @return {String}
	 */
	function spm_getParamForAD(el) {
		var parent_node = el.parentNode;
		if (!parent_node) return "";

		var spm_d = el.getAttribute(s_SPM_ATTR_NAME);
		var parent_obj = spm_spmGetParentSPMId(parent_node);
		var spm_c = parent_obj.spm_c || 0;

		if (spm_c && spm_c.indexOf(".") != -1) {
			// 处理a.b.c这样的情况
			spm_c = spm_c.split(".");
			spm_c = spm_c[spm_c.length - 1];
		}

		var spm_abc = spm_ab + "." + spm_c;
		var spm_d_idx = spm_d_for_ad[spm_abc] || 0;

		spm_d_idx++;
		spm_d_for_ad[spm_abc] = spm_d_idx;

		spm_d = spm_d || spm_d_idx;

		// 注意这儿d位有一个“i”前缀，表示广告iframe
		return spm_abc + ".i" + spm_d;
	}


	/**
	 * 返回指定元素的 SPM 参数值
	 * @param el {Element}
	 * @return {Object}
	 */
	function spm_getSPMParam(el) {

		var tag_name = el.tagName;
		var anchor_id;

		pvid = win["g_aplus_pv_id"];

		if (tag_name != "A" && tag_name != "AREA") {
			anchor_id = spm_getParamForAD(el);
		} else {
			spm_spmAnchorChk(el, s_true);
			anchor_id = tryToGetAttribute(el, s_DATA_SPM_ANCHOR_ID);
		}
		anchor_id = (anchor_id || "0.0.0.0").split(".");

		return {
			a: anchor_id[0],
			b: anchor_id[1],
			c: anchor_id[2],
			d: anchor_id[3]
		};
	}

	/**
	 * 返回指定元素的 SPM 参数值
	 * @param el {Element}
	 * @return {String}
	 */
	function spm_forwap(el) {
		var spm_obj = spm_getSPMParam(el);
		return spm_obj["a"] + "." + spm_obj["b"] + "." + spm_obj["c"] + "." + spm_obj["d"];
	}

	/**
	 * 无痕SPM打点初始化
	 */
	function init_wh() {
		if (wh_spm_initialized) return;

		if (!win["spmData"]) {
			if (!is_dom_ready) {
				setTimeout(init_wh, 100);
			}
			return;
		}
		wh_spm_initialized = s_true;

		/** spmData 数据格式形如：
		 *
		 * {'data': [
		 *         {
		 *             "spmc": "1000891",
		 *             "spmd": "",
		 *             "xpath": "/html[1]/body[1]/table[2]/tbody[1]/tr[1]/td[2]/div[1]/div[3]"
		 *         }
		 * ]};
		 */

		var data = win["spmData"]["data"],
			i, l,
			idata,
			xpath;

		if (!data || !isArray(data)) return;

		for (i = 0, l = data.length; i < l; i++) {
			idata = data[i];
			xpath = idata.xpath;
			wh_spm_data[xpath] = {
				spmc: idata.spmc,
				spmd: idata.spmd
			};
		}
	}

	/**
	 * 监视带data-spm-src属性的iframe
	 * 查找并更新它们的src
	 */
	function watchSPMIframe() {
		var iframes = doc.getElementsByTagName("iframe");
		var ifr;
		var i;
		var l = iframes.length;
		var spm_src;
		var spm_id;

		for (i = 0; i < l; i++) {
			ifr = iframes[i];
			if (ifr.src || !(spm_src = tryToGetAttribute(ifr, s_SPM_SRC))) continue;
			spm_id = spm_getSPMParam(ifr);
			if (spm_id) {
				spm_id = [
					spm_id["a"], spm_id["b"], spm_id["c"], spm_id["d"], spm_id["e"]
				].join(".");
				ifr.src = spm_updateHrefWithSPMId(spm_src, spm_id);
			} else {
				ifr.src = spm_src;
			}
		}
	}

	function init_watchSPMIframe() {
		var count = 0;
		var sleep_time = 500;

		function f() {
			count++;
			if (count > 10) sleep_time = 3000;
			watchSPMIframe();
			setTimeout(f, sleep_time);
		}

		f();
	}

	/**
	 * 航旅独有:在无痕埋点中加入gokey用于传递额外参数
	 * @returns {string}
     */
	function createPrismKey(){
		if(window._prism_lk){
			return "_prism_lk=" + encodeURIComponent(JSON.stringify(window._prism_lk));
		}
		return "";
	}

	function onSPMClick(el, data) {
		// <div data-spm-click="..."> .. </div>
		// data 形如：gostr=/tbdetail;locaid=d1;unknowkey=123;k1=v1&k2=v2&k3=v3

		var name_gostr = "gostr";
		var name_locaid = "locaid";
		var gostr;
		var locaid;
		var dict = {};
		parseMetaContent(data, dict);



		gostr = dict[name_gostr];
		locaid = dict[name_locaid];

		// 参数不完整，退出
		if (!gostr || !locaid) return;
		if (isStartWith(gostr, "/")) gostr = gostr.substr(1);

		var spm_params = spm_getSPMParam(el);
		var spm_id = [
			spm_params.a,
			spm_params.b,
			spm_params.c,
			locaid
		].join(".");
		var req_path = gostr + "." + spm_id;

		var params = [
			"logtype=2",
			"cache=" + Math.random(),
			"autosend=1",
			"spm-cnt="+ [spm_params.a,spm_params.b,0,0].join('.'),
			createPrismKey()//航旅独有
		];
		var k;
		for (k in dict) {
			if (!dict.hasOwnProperty(k)) continue;
			if (k != name_gostr && k != name_locaid) {
				params.push(k + "=" + dict[k]);
			}
		}
		if (params.length > 0) {
			req_path += "?" + params.join("&");
		}

		// 同步到 UT

		//------------- 航旅私有 追加当前页面的URL查询参数到无痕打点日志 start --------------
		var urlParams = location.search.slice(1);
		var urlHash = location.hash.slice(1);
		params.push("_h5params=" + encodeURIComponent(urlParams));
		params.push("_h5hash="   + encodeURIComponent(urlHash));
		//------------- 航旅私有 追加当前页面的URL查询参数到无痕打点日志 end --------------
		var windVaneData,
			logkeyargs = {
				gmkey: '',
				gokey: params.length > 0 ? params.join('&') : ''
			};

		if (win.goldlog && win.goldlog.call && (windVaneData = win.goldlog.windVaneData)) {

			try {
				logkeyargs = JSON.stringify(logkeyargs);
				if (logkeyargs == "{}") {
					logkeyargs = "";
				}
			} catch (err) {
				logkeyargs = "";
			}

			windVaneData["functype"] = "2101";
			windVaneData["logkey"] = '/' + gostr + '.' + spm_id;
			windVaneData["logkeyargs"] = logkeyargs;
			windVaneData["extendargs"] = "";

			delete windVaneData["spmcnt"];
			delete windVaneData["spmpre"];
			delete windVaneData["lzsid"];

			win.goldlog.call("WVTBUserTrack", "toUT", windVaneData);
		}

		sendData(hjlj_beacon_base + req_path);
		el.setAttribute(s_DATA_SPM_ANCHOR_ID, spm_id);
	}

	function hjlj_spmClick(el) {

		var val;
		while (el && el.tagName != s_HTML) {
			val = tryToGetAttribute(el, s_SPM_CLICK);
			if (!val) {
				el = el.parentNode;
				continue;
			}

			onSPMClick(el, val);
			break;
		}
	}

	function init_hjlj_spmClick() {
		if (isTouchEnabled) {
			addEventListener(doc, "tap", hjlj_spmClick);
		} else {
			addEventListener(doc, "mousedown", hjlj_spmClick);
		}
	}

	function doTrace(el) {
		var tag_name;
		while (el && (tag_name = el.tagName)) {
			if (tag_name == "A" || tag_name == "AREA") {
				// 点到了链接上
				spm_spmAnchorChk(el, s_false);
				break;
			} else if (tag_name == s_BODY || tag_name == s_HTML) break;

			el = el.parentNode;
		}
	}


	// ----------
	// 以上都是各种定义，下面开始是 SPM 执行方法

	if (isContain2(page_url, [ // spm 黑名单
			"xiaobai.com",
			"admin.taobao.org"
		])) return;

	onDOMReady(function () {
		is_dom_ready = s_true;
	});
	init_getGlobalSPMId();
	init_wh(); // 无痕初始化
	init_watchSPMIframe();
	init_hjlj_spmClick();

	/**
	 * 绑定 document 的 mousedown 事件，当元素被点击时判断它是否为链接，并检查是否需要更新其 spm_id
	 */
	if (isTouchEnabled) {
		addEventListener(doc, "tap", doTrace);
	} else {
		addEventListener(doc, "mousedown", doTrace);
		addEventListener(doc, "keydown", doTrace);
	}


	/**
	 * 全局 SPM 方法
	 * @see http://wiki.ued.taobao.net/doku.php?id=team:udc:f2e:unified-beacon:spm-openapi
	 * @type {Object}
	 */
	win.g_SPM = {
		resetModule: spm_resetModule,
		anchorBeacon: spm_spmAnchorChk,
		getParam: spm_getSPMParam,
		// 2014-06-04 梵易需求,配合无线端
		spm: spm_forwap
	};

})();



/*****************
 ** WEBPACK FOOTER
 ** ./components/wlog/src/spm_wap.js
 ** module id = 16
 ** module chunks = 0
 **/